import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BookingForm from '../components/BookingForm';

function BookingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const city = useParams();
  
  const preselectedService = location.state?.service || null;

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <BookingForm 
        preselectedService={preselectedService}
        onBack={handleBack}
        userType={location.state?.userType}
        city={city.cityName}
      />
    </div>
  );
}

export default BookingPage;